// =============================================================================
// MHV Live Main — Countdown, layout, orientation, gesture detection
// Extracted from sections/live.liquid (Script Blocks 1 + 2)
//
// Reads config from window.MHV_LIVE_CONFIG (injected by live.liquid):
//   livetime, auctionEnded, customer, showSlideshow, requestsAllowed, auctionDateCode
// Depends on: mhv-utils.js (MHV.easternToUTC), live-player.js (updateMuteButtonUI, etc.)
// =============================================================================

(function() {
  'use strict';

  var CONFIG = window.MHV_LIVE_CONFIG || {};

  // =================================
  // Safe DOM helpers
  // =================================
  function $id(x) { return document.getElementById(x); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }

  function safeSetText(id, text) {
    var el = $id(id);
    if (el) el.innerText = text;
  }
  window.safeSetText = safeSetText;

  // =================================
  // Countdown System
  // =================================
  window.isOverlayActive = false;
  window.countdownClosedByUser = false;

  function updateCountdown() {
    try {
      var chatCountdownElement = $id('chat-countdown-content');
      var chatDaysElement = $id('chat-days');
      var chatHoursElement = $id('chat-hours');
      var chatMinutesElement = $id('chat-minutes');
      var chatSecondsElement = $id('chat-seconds');

      if (!chatCountdownElement || !chatDaysElement || !chatHoursElement || !chatMinutesElement || !chatSecondsElement) {
        return;
      }

      var liveTimeStr = CONFIG.livetime || CONFIG._cachedLivetime || '';
      if (!liveTimeStr || liveTimeStr.length < 16) {
        chatCountdownElement.classList.add('hidden');
        return;
      }

      var year = parseInt(liveTimeStr.slice(0, 4), 10);
      var month = parseInt(liveTimeStr.slice(5, 7), 10);
      var day = parseInt(liveTimeStr.slice(8, 10), 10);
      var hour = parseInt(liveTimeStr.slice(11, 13), 10);
      var minute = parseInt(liveTimeStr.slice(14, 16), 10);
      var countdownDate = MHV.easternToUTC(year, month, day, hour, minute);
      var now = new Date();
      var distance = countdownDate.getTime() - now.getTime();

      var auctionEnded = CONFIG.auctionEnded;
      var isLoggedIn = CONFIG.customer !== null;

      if (distance < 0) {
        if (auctionEnded) {
          showAuctionEndedMessage();
        } else {
          showAuctionNightMessage(isLoggedIn);
        }
        return;
      }

      if (!window.countdownClosedByUser) {
        chatCountdownElement.classList.remove('hidden');
        window.isOverlayActive = true;
      } else {
        chatCountdownElement.classList.add('hidden');
        window.isOverlayActive = false;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      safeSetText('chat-days', days < 10 ? '0' + days : days);
      safeSetText('chat-hours', hours < 10 ? '0' + hours : hours);
      safeSetText('chat-minutes', minutes < 10 ? '0' + minutes : minutes);
      safeSetText('chat-seconds', seconds < 10 ? '0' + seconds : seconds);

      var liveShowInfoElement = $id('chat-live-show-info');
      if (liveShowInfoElement) {
        var localShowDate = new Date(countdownDate.getTime());
        var dayOfWeek = localShowDate.toLocaleDateString(undefined, { weekday: 'long' }).toUpperCase();
        var dateStr = localShowDate.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric', year: '2-digit' });
        var localHours = localShowDate.getHours();
        var localMinutes = localShowDate.getMinutes();
        var ampm = localHours >= 12 ? 'PM' : 'AM';
        localHours = localHours % 12;
        if (localHours === 0) localHours = 12;
        var timeStr = (localMinutes === 0)
          ? localHours + ampm
          : localHours + ':' + (localMinutes < 10 ? '0' + localMinutes : localMinutes) + ampm;
        var tzString = localShowDate.toLocaleTimeString(undefined, { timeZoneName: 'short' }).split(' ').pop();
        safeSetText('chat-live-show-info', dayOfWeek + ' ' + dateStr + ' ' + timeStr + ' ' + tzString);
      }
    } catch (error) {
      console.error('Countdown error:', error);
    }
  }
  window.updateCountdown = updateCountdown;

  function showAuctionEndedMessage() {
    var countdownDisplay = $id('countdown-display');
    if (countdownDisplay) countdownDisplay.style.display = 'none';

    var auctionNightDisplay = $id('auction-night-display');
    if (auctionNightDisplay) {
      auctionNightDisplay.style.display = 'block';
      var titleElement = auctionNightDisplay.querySelector('.auction-night-title');
      var subtitleElement = auctionNightDisplay.querySelector('.auction-night-subtitle');
      if (titleElement) titleElement.innerHTML = '<div>THE AUCTION HAS ENDED!</div><div>THANK YOU!</div>';
      if (subtitleElement) subtitleElement.textContent = '';

      var loggedInSection = $id('auction-night-logged-in');
      var loggedOutSection = $id('auction-night-logged-out');
      if (loggedInSection) loggedInSection.style.display = 'none';
      if (loggedOutSection) loggedOutSection.style.display = 'none';
    }
  }
  window.showAuctionEndedMessage = showAuctionEndedMessage;

  function showAuctionNightMessage(isLoggedIn) {
    var countdownDisplay = $id('countdown-display');
    if (countdownDisplay) countdownDisplay.style.display = 'none';

    var auctionNightDisplay = $id('auction-night-display');
    if (auctionNightDisplay) auctionNightDisplay.style.display = 'block';

    if (!window.countdownClosedByUser) {
      window.isOverlayActive = true;
    } else {
      window.isOverlayActive = false;
    }

    var loggedInSection = $id('auction-night-logged-in');
    var loggedOutSection = $id('auction-night-logged-out');

    if (isLoggedIn) {
      if (loggedInSection) loggedInSection.style.display = 'block';
      if (loggedOutSection) loggedOutSection.style.display = 'none';
    } else {
      if (loggedInSection) loggedInSection.style.display = 'none';
      if (loggedOutSection) loggedOutSection.style.display = 'none';
    }
  }
  window.showAuctionNightMessage = showAuctionNightMessage;

  function closeChatOverlay() {
    var chatOverlay = $id('chat-overlay');
    var isLoggedIn = CONFIG.customer !== null;

    if (chatOverlay && isLoggedIn) {
      chatOverlay.classList.add('hidden');
      window.countdownClosedByUser = true;
      if (window.countdownInterval) {
        clearInterval(window.countdownInterval);
        window.countdownInterval = null;
      }
      window.isOverlayActive = false;
    }
  }
  window.closeChatOverlay = closeChatOverlay;

  function initializeCountdown() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window.initializeCountdown);
      return;
    }
    var chatCountdownElement = $id('chat-countdown-content');
    if (!chatCountdownElement) {
      setTimeout(window.initializeCountdown, 500);
      return;
    }

    // Fetch live status from schedule API to replace page metafield
    fetch(MHV.SERVER_URL + '/api/schedule/live-status')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.livetime) CONFIG._cachedLivetime = data.livetime;
        if (data.ended) CONFIG.auctionEnded = true;
        startCountdownLoop();
      })
      .catch(function() {
        // Fall back to Liquid-injected config
        startCountdownLoop();
      });
  }

  function startCountdownLoop() {
    window.updateCountdown();
    if (!window.countdownInterval) {
      window.countdownInterval = setInterval(window.updateCountdown, 1000);
    }
  }
  window.initializeCountdown = initializeCountdown;

  // Also provide easternToUTC globally via mhv-utils.js
  window.easternToUTC = MHV.easternToUTC;

  // =================================
  // Video Player Height
  // =================================
  function updateVideoPlayerHeight() {
    var videoPlayer = document.querySelector('#video-container, .video-player, video, iframe[src*="youtube"], iframe[src*="vimeo"]');
    if (videoPlayer) {
      document.documentElement.style.setProperty('--video-player-height', videoPlayer.offsetHeight + 'px');
    } else {
      document.documentElement.style.setProperty('--video-player-height', '50vh');
    }
  }

  window.addEventListener('load', updateVideoPlayerHeight);
  (function() {
    var videoResizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(videoResizeTimeout);
      videoResizeTimeout = setTimeout(updateVideoPlayerHeight, 200);
    });
  })();

  // =================================
  // Stream badge helpers
  // =================================
  function badge(text) {
    var b = $id('stream-badge');
    if (!b) return;
    b.textContent = text;
    b.style.display = 'inline-block';
  }
  function hideBadge() {
    var b = $id('stream-badge');
    if (!b) return;
    b.style.display = 'none';
  }
  window.badge = badge;
  window.hideBadge = hideBadge;

  // =================================
  // Video element helper
  // =================================
  function ensureVideoElement() {
    return document.querySelector('#mhv-webrtc-player video') || null;
  }
  window.ensureVideoElement = ensureVideoElement;

  // =================================
  // Live lifecycle polling
  // =================================
  function pollLiveStatus(opts) {
    var lifecycleUrl = opts.lifecycleUrl;
    var intervalMs = opts.intervalMs || 4000;
    var timeoutMs = opts.timeoutMs || 120000;
    var start = Date.now();
    return new Promise(function(resolve) {
      (function poll() {
        if (Date.now() - start >= timeoutMs) { resolve(false); return; }
        fetch(lifecycleUrl, { method: 'GET', cache: 'no-store' })
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(j) {
            if (j && (j.status === 'live' || (j.input && j.input.status === 'live') || j.live === true)) {
              resolve(true);
            } else {
              setTimeout(poll, intervalMs);
            }
          })
          .catch(function() { setTimeout(poll, intervalMs); });
      })();
    });
  }
  window.pollLiveStatus = pollLiveStatus;

  // =================================
  // Slideshow visibility state
  // =================================
  var isSlideshowVisible = true;
  var savedVisibility = localStorage.getItem('chatSlidesSlideshowVisible');
  if (savedVisibility !== null) {
    isSlideshowVisible = savedVisibility === 'true';
  }
  window.isSlideshowVisible = isSlideshowVisible;

  // Slideshow state variables (global scope, shared with live-page.js and live-slideshow.js)
  window.currentImages = [];
  window.currentSlideIndex = 0;
  window.slideshowInterval = null;
  window.hasCompletedCycle = false;
  window.isPhotoGallery = false;

  function setInitialSlideshowState() {
    var slideshowContainer = $id('product-slideshow-container');
    var videoContainer = $id('whep-player-container');
    if (slideshowContainer && videoContainer) {
      slideshowContainer.style.display = 'none';
      videoContainer.style.display = 'flex';
    }
  }

  // =================================
  // iOS detection & orientation
  // =================================
  function isIOSStrict() {
    var ua = navigator.userAgent || '';
    var platform = navigator.platform || (navigator.userAgentData && navigator.userAgentData.platform) || '';
    if (/iPhone|iPad|iPod/.test(platform)) return true;
    return /Mac/.test(platform) && 'ontouchend' in window && /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/.test(ua);
  }
  window.isIOSStrict = isIOSStrict;

  if (/Mobi|Android/i.test(navigator.userAgent)) {
    document.documentElement.classList.add('mobile-device');
  }

  var originalViewportHeight = window.innerHeight;
  var initialOrientation = (window.innerHeight > window.innerWidth) ? 'portrait' : 'landscape';

  if (initialOrientation === 'portrait') {
    document.documentElement.classList.add('portrait-mode');
  } else {
    document.documentElement.classList.add('landscape-mode');
  }

  document.documentElement.style.setProperty('--viewport-height', originalViewportHeight + 'px');
  document.documentElement.style.setProperty('--original-height', originalViewportHeight + 'px');

  function updateOrientation() {
    if (window.innerWidth > window.innerHeight) {
      document.documentElement.classList.remove('portrait-mode');
      document.documentElement.classList.add('landscape-mode');
      initialOrientation = 'landscape';
    } else {
      document.documentElement.classList.remove('landscape-mode');
      document.documentElement.classList.add('portrait-mode');
      initialOrientation = 'portrait';
    }
  }

  // =================================
  // Layout management
  // =================================
  var chatIsOpen = false;

  function debounce(func, wait) {
    var timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }
  window.debounce = debounce;

  function isMobile() {
    return document.documentElement.classList.contains('mobile-device');
  }
  window.isMobile = isMobile;

  function adjustLayoutContainerHeight() {
    if (isMobile() && document.documentElement.classList.contains('landscape-mode')) {
      var layoutContainer = document.querySelector('.layout-container');
      var castrInterface = document.querySelector('.castr-interface');
      if (layoutContainer) layoutContainer.style.height = '';
      if (castrInterface) castrInterface.style.height = '';
      return;
    }

    var currentHeight = (window.visualViewport && window.visualViewport.height) ? window.visualViewport.height : window.innerHeight;
    if (isMobile() && initialOrientation === 'portrait' && currentHeight < originalViewportHeight) {
      currentHeight = originalViewportHeight;
    }
    var layoutContainer = document.querySelector('.layout-container');
    if (layoutContainer) layoutContainer.style.height = currentHeight + 'px';
    document.documentElement.style.setProperty('--viewport-height', currentHeight + 'px');
    document.documentElement.style.setProperty('--original-height', currentHeight + 'px');

    if (isIOSStrict() && initialOrientation === 'portrait' && window.visualViewport) {
      var lc = document.querySelector('.layout-container');
      if (lc) {
        var keyboardHeight = originalViewportHeight - (window.visualViewport.offsetTop + window.visualViewport.height);
        if (keyboardHeight > 0) {
          lc.style.position = 'absolute';
          lc.style.top = '0';
          lc.style.transform = 'translateY(-' + keyboardHeight + 'px)';
        } else {
          lc.style.position = '';
          lc.style.top = '';
          lc.style.transform = '';
        }
      }
    }

    if (isIOSStrict() && initialOrientation === 'landscape' && window.visualViewport) {
      var chatInterface = document.querySelector('.chat-interface.active-chat');
      if (chatInterface) {
        var kbHeight = originalViewportHeight - (window.visualViewport.offsetTop + window.visualViewport.height);
        chatInterface.style.bottom = (kbHeight > 0 ? kbHeight : 0) + 'px';
      }
    }
  }

  if (isIOSStrict() && window.visualViewport) {
    var visualViewportTimeout;
    var debouncedAdjust = function() {
      clearTimeout(visualViewportTimeout);
      visualViewportTimeout = setTimeout(adjustLayoutContainerHeight, 50);
    };
    window.visualViewport.addEventListener('resize', debouncedAdjust);
    window.visualViewport.addEventListener('scroll', debouncedAdjust);
  }

  // =================================
  // Chat modal
  // =================================
  function openChat() {
    var chatInterface = document.querySelector('.chat-interface');
    var castrInterface = document.querySelector('.castr-interface');
    var backdrop = $id('chat-backdrop');
    if (!chatInterface) return;

    if (castrInterface) {
      if (!castrInterface.dataset.originalStyle) {
        castrInterface.dataset.originalStyle = castrInterface.getAttribute('style') || '';
      }
      castrInterface.style.position = 'static';
    }

    chatInterface.classList.add('active-chat');
    chatInterface.style.display = 'block';
    chatInterface.style.position = 'fixed';
    chatInterface.style.bottom = '0';
    chatInterface.style.left = '50%';
    chatInterface.style.transform = 'translateX(-50%)';
    chatInterface.style.width = '75vw';
    chatInterface.style.height = '66.67vh';
    chatInterface.style.zIndex = '1000';
    chatInterface.style.overflowY = 'auto';

    if (document.documentElement.classList.contains('landscape-mode')) {
      chatIsOpen = true;
      history.pushState({ chat: true }, '');
      if (backdrop) backdrop.style.display = 'block';
    }
  }
  window.openChat = openChat;

  function hideChat() {
    var chatInterface = document.querySelector('.chat-interface');
    var castrInterface = document.querySelector('.castr-interface');
    var backdrop = $id('chat-backdrop');
    if (!chatInterface || !chatInterface.classList.contains('active-chat')) return;

    chatInterface.classList.remove('active-chat');
    chatInterface.style.display = 'none';

    if (castrInterface) {
      if (castrInterface.dataset.originalStyle !== undefined) {
        castrInterface.setAttribute('style', castrInterface.dataset.originalStyle);
      } else {
        castrInterface.removeAttribute('style');
      }
    }

    if (document.documentElement.classList.contains('landscape-mode') && chatIsOpen) {
      chatIsOpen = false;
      history.pushState(null, '');
      if (backdrop) backdrop.style.display = 'none';
    }
  }
  window.hideChat = hideChat;

  function toggleChat() {
    var chatInterface = document.querySelector('.chat-interface');
    if (!chatInterface) return;
    if (chatInterface.classList.contains('active-chat')) {
      hideChat();
    } else {
      openChat();
    }
  }
  window.toggleChat = toggleChat;

  // =================================
  // Orientation change handler
  // =================================
  function handleOrientationChange() {
    if (document.activeElement) document.activeElement.blur();

    updateOrientation();
    originalViewportHeight = window.innerHeight;
    document.documentElement.style.setProperty('--viewport-height', originalViewportHeight + 'px');
    document.documentElement.style.setProperty('--original-height', originalViewportHeight + 'px');

    var chatInterface = document.querySelector('.chat-interface');
    var castrInterface = document.querySelector('.castr-interface');

    if (castrInterface) castrInterface.removeAttribute('style');

    var layoutContainer = document.querySelector('.layout-container');
    if (layoutContainer) layoutContainer.removeAttribute('style');

    adjustLayoutContainerHeight();

    if (initialOrientation === 'landscape') {
      if (chatInterface) {
        chatInterface.classList.remove('active-chat');
        chatInterface.style.display = 'none';
      }
    }

    if (initialOrientation === 'portrait') {
      if (chatInterface) {
        chatInterface.classList.remove('active-chat');
        chatInterface.removeAttribute('style');
      }
      if (castrInterface) castrInterface.classList.add('fixed');

      var backdrop = $id('chat-backdrop');
      if (backdrop) backdrop.style.display = 'none';
      chatIsOpen = false;

      setTimeout(function() {
        adjustLayoutContainerHeight();
      }, 300);
    }
  }

  // =================================
  // OvenPlayer pointer-events workaround
  // =================================
  function enforceOverlayInteractivity() {
    try {
      var ovenContainer = $id('mhv-webrtc-player');
      if (ovenContainer) {
        ovenContainer.style.pointerEvents = 'none';
        ovenContainer.style.zIndex = '1';
      }
      var ovenVideo = document.querySelector('#mhv-webrtc-player video');
      if (ovenVideo) {
        ovenVideo.style.pointerEvents = 'none';
        ovenVideo.style.zIndex = '1';
      }
      var els = document.querySelectorAll('#mhv-webrtc-player *');
      for (var i = 0; i < els.length; i++) {
        try { els[i].style.pointerEvents = 'none'; } catch (e) {}
      }
    } catch (e) {}
  }

  function observeOvenPlayerVideo() {
    var container = $id('mhv-webrtc-player');
    if (!container || container.__mhvObserver) return;
    var obs = new MutationObserver(function() { enforceOverlayInteractivity(); });
    obs.observe(container, { childList: true, subtree: true });
    container.__mhvObserver = obs;
  }

  // =================================
  // Display live show date/time
  // =================================
  function displayLiveShowDateTime() {
    var liveTimeStr = CONFIG.livetime || '';
    if (liveTimeStr && liveTimeStr.length >= 16) {
      var year = parseInt(liveTimeStr.slice(0, 4), 10);
      var month = parseInt(liveTimeStr.slice(5, 7), 10);
      var day = parseInt(liveTimeStr.slice(8, 10), 10);
      var hour = parseInt(liveTimeStr.slice(11, 13), 10);
      var minute = parseInt(liveTimeStr.slice(14, 16), 10);
      var countdownDate = MHV.easternToUTC(year, month, day, hour, minute);
      var localShowDate = new Date(countdownDate.getTime());
      var dayOfWeek = localShowDate.toLocaleDateString(undefined, { weekday: 'long' }).toUpperCase();
      var dateStr = localShowDate.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric', year: '2-digit' });
      var localHours = localShowDate.getHours();
      var localMinutes = localShowDate.getMinutes();
      var ampm = localHours >= 12 ? 'PM' : 'AM';
      localHours = localHours % 12;
      if (localHours === 0) localHours = 12;
      var timeStr = (localMinutes === 0)
        ? localHours + ampm
        : localHours + ':' + (localMinutes < 10 ? '0' + localMinutes : localMinutes) + ampm;
      var tzString = localShowDate.toLocaleTimeString(undefined, { timeZoneName: 'short' }).split(' ').pop();
      var liveShowInfo = dayOfWeek + ' ' + dateStr + ' ' + timeStr + ' ' + tzString;
      safeSetText('live-show-info', liveShowInfo);
    }
  }

  // =================================
  // DOMContentLoaded initialization
  // =================================
  document.addEventListener('DOMContentLoaded', function() {
    if (window.__LIVE_INIT_DONE__) return;
    window.__LIVE_INIT_DONE__ = true;

    adjustLayoutContainerHeight();

    try {
      if (typeof window.updateCountdown === 'function') {
        window.updateCountdown();
      }
    } catch (error) {
      console.error('Error calling updateCountdown:', error);
    }

    initializeAudioInteraction();
    setInitialSlideshowState();

    // Request current slideshow state after socket connects
    setTimeout(function() {
      if (typeof window.requestSlideshowState === 'function') {
        window.requestSlideshowState();
      }
    }, 1000);

    // Periodic slideshow state sync every 5 minutes
    setInterval(function() {
      if (window.socket && window.socket.connected && typeof window.requestSlideshowState === 'function') {
        window.requestSlideshowState();
      }
    }, 5 * 60 * 1000);

    if (typeof window.initializeSlideshow === 'function') {
      try {
        window.initializeSlideshow();
      } catch (error) {
        console.error('Error initializing slideshow:', error);
      }
    }

    // Audio interaction initialization for OvenPlayer
    function initializeAudioInteraction() {
      if (/Android/i.test(navigator.userAgent)) {
        setTimeout(function() {
          try {
            var audioContext = new (window.AudioContext || window.webkitAudioContext)();
            window.mhvAudioContext = audioContext;
          } catch (e) {}
        }, 1000);
      }
    }

    // Track user interactions and use first real gesture to trigger player play
    window.userHasInteracted = false;

    function __mhvUnmuteAndPlay() {
      try {
        if (window.mhvAudioContext && window.mhvAudioContext.state === 'suspended') {
          window.mhvAudioContext.resume().catch(function() {});
        }

        var player = window._mhvPlayer;
        if (player) {
          try {
            if (typeof player.setMute === 'function') {
              player.setMute(false);
              window.mhvMuteState = false;
              if (typeof window.updateMuteButtonUI === 'function') window.updateMuteButtonUI(false);
            }
          } catch (e) {}
          try {
            if (typeof player.unmute === 'function') {
              player.unmute();
              window.mhvMuteState = false;
              if (typeof window.updateMuteButtonUI === 'function') window.updateMuteButtonUI(false);
            }
          } catch (e) {}
          try {
            if (typeof player.play === 'function') {
              player.play();
              window.mhvPlayState = true;
              if (typeof window.updatePlayPauseButtonUI === 'function') window.updatePlayPauseButtonUI(true);
            }
          } catch (e) {}
          return true;
        }
        var ovenVideo = document.querySelector('#mhv-webrtc-player video');
        if (ovenVideo) {
          if (typeof ovenVideo.muted === 'boolean') {
            ovenVideo.muted = false;
            window.mhvMuteState = false;
            if (typeof window.updateMuteButtonUI === 'function') window.updateMuteButtonUI(false);
          }
          var p = ovenVideo.play();
          if (p && typeof p.then === 'function') {
            p.then(function() {
              window.mhvPlayState = true;
              if (typeof window.updatePlayPauseButtonUI === 'function') window.updatePlayPauseButtonUI(true);
            }).catch(function() {});
          }
          return true;
        }
      } catch (e) {}
      return false;
    }

    function __mhvOnUserGesture(event) {
      if (event && event.target) {
        var target = event.target;
        var isCustomButton = target.closest && (target.closest('#mute-toggle-btn') || target.closest('#play-pause-btn'));
        if (isCustomButton) return;
      }

      window.userHasInteracted = true;
      if (window.__mhvUserGesturePlayDone) return;

      var attempts = 0;
      var maxAttempts = 40;
      var tryPlay = function() {
        if (__mhvUnmuteAndPlay()) {
          window.__mhvUserGesturePlayDone = true;
          clearInterval(timer);
        } else if (++attempts >= maxAttempts) {
          clearInterval(timer);
        }
      };
      tryPlay();
      var timer = setInterval(tryPlay, 100);
    }

    document.addEventListener('click', __mhvOnUserGesture, { capture: true, passive: true });
    document.addEventListener('touchend', __mhvOnUserGesture, { capture: true, passive: true });
    document.addEventListener('keydown', __mhvOnUserGesture, { capture: true, passive: true });

    try { observeOvenPlayerVideo(); } catch (e) {}

    var backdrop = $id('chat-backdrop');
    if (backdrop) {
      on(backdrop, 'click', function() { hideChat(); });
    }

    window.addEventListener('popstate', function() {
      var activeChat = document.querySelector('.chat-interface.active-chat');
      if (document.documentElement.classList.contains('landscape-mode') && activeChat) {
        hideChat();
        history.pushState({ chat: true }, '');
      }
    });

    // Display the live show's local date and time
    displayLiveShowDateTime();
  });

  // =================================
  // Resize/orientation handlers
  // =================================
  if (!isMobile()) {
    window.addEventListener('resize', debounce(function() {
      adjustLayoutContainerHeight();
    }, 500));
  } else {
    window.addEventListener('resize', debounce(function() {
      adjustLayoutContainerHeight();
    }, 300));
    window.addEventListener('orientationchange', debounce(function() {
      handleOrientationChange();
    }, 300));
    window.addEventListener('scroll', function() {
      window.scrollTo(0, 0);
    });
  }

  // Initialize countdown immediately
  window.initializeCountdown();
})();
